module.exports = __webpack_public_path__ + "static/media/pages.9cf1b347.svg";